import { Link } from "react-router-dom";

export default function WhatWeDo() {
  const cards = [
    { id: "1", src: "/AutoHaus-1.png", title: "AutoHaus", subtitle: "Branding | PR" },
    { id: "2", src: "/cms14.jpeg", title: "Creative Corner Summit", subtitle: "Branding | PR" },
    { id: "3", src: "/crunchies.jpg", title: "Crunchies Fried Chicken", subtitle: "Branding | PR" },
    { id: "4", src: "/bistro.jpg", title: "Bistro23", subtitle: "Branding | PR" },
    { id: "5", src: "/roots.jpg", title: "Roots Restaurant", subtitle: "Branding | PR" },
    { id: "1", src: "/AutoHaus-1.png", title: "AutoHaus", subtitle: "Branding | PR" },
    { id: "2", src: "/cms14.jpeg", title: "Creative Corner Summit", subtitle: "Branding | PR" },
    { id: "3", src: "/crunchies.jpg", title: "Crunchies Fried Chicken", subtitle: "Branding | PR" },
    { id: "4", src: "/bistro.jpg", title: "Bistro23", subtitle: "Branding | PR" },
    { id: "5", src: "/roots.jpg", title: "Roots Restaurant", subtitle: "Branding | PR" },
    { id: "1", src: "/AutoHaus-1.png", title: "AutoHaus", subtitle: "Branding | PR" },
    { id: "2", src: "/cms14.jpeg", title: "Creative Corner Summit", subtitle: "Branding | PR" },
    { id: "3", src: "/crunchies.jpg", title: "Crunchies Fried Chicken", subtitle: "Branding | PR" },
    { id: "4", src: "/bistro.jpg", title: "Bistro23", subtitle: "Branding | PR" },
    { id: "5", src: "/roots.jpg", title: "Roots Restaurant", subtitle: "Branding | PR" },
  ];

  const loopCards = [...cards, ...cards];

  return (
    <section className="py-16 overflow-hidden">
      <style>
        {`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-marquee {
            display: flex;
            width: max-content;
            animation: marquee 40s linear infinite;
          }
        `}
      </style>

      <div className="w-full max-w-[1440px] mx-auto">
        {/* Heading Section */}
        <div className="px-1 mb-4 lg:mb-10 text-center lg:text-left lg:ml-[320px]">
          {/* Add heading text here if needed */}
        </div>

        {/* Carousel container */}
        <div className="relative overflow-hidden">
          <div className="animate-marquee">
            {loopCards.map((card, i) => (
              <Link
                key={i}
                to={`/project/${card.id}`}
                className="flex-shrink-0 w-[75vw] sm:w-[300px] mx-2 group block"
              >
                {/* Reduced aspect ratio to reduce height */}
                <div className="rounded-lg overflow-hidden aspect-[3/3.7]">
                  <img
                    src={card.src}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="mt-4 px-1">
                  <p className="font-bold text-black text-lg">{card.title}</p>
                  <p className="text-gray-500 text-sm font-medium">{card.subtitle}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}